import React from 'react';
import { AlertIcon, InfoIcon } from '../icons/Icons';
import './Banner.scss';

interface BannerProps {
  kind: 'info' | 'error';
  children: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

const Banner = ({ kind, children, action, className }: BannerProps) => (
  <div role={kind === 'error' ? 'alert' : 'status'} className={`Banner Banner--${kind} ${className ?? ''}`}>
    {kind === 'error' ? <AlertIcon className="Banner__icon" /> : <InfoIcon stroke="#13305C" className="Banner__icon" />}
    <span className="Banner__text">{children}</span>
    {action}
  </div>
);

export default Banner;
